import { render } from "./_settings.vue?vue&type=template&id=477a2d5e&ts=true"
import script from "./_settings.vue?vue&type=script&lang=ts"
export * from "./_settings.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./_settings.vue?vue&type=style&index=0&id=477a2d5e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__